import { ReactNode, createContext } from 'react';

export type CollapsibleValues = { open: boolean; children?: ReactNode };

const CollapsibleContext = createContext<CollapsibleValues>({ open: false });

export default CollapsibleContext;
